<template>
  <div class="mobile">
    <nav class="nav">
      <div
        v-show="isPreviewActive"
        class="nav__prev"
        @click="isPreviewActive = false"
      >
        <i class="isif isif-arrow-left" />
      </div>
      <div
        v-if="!disableClose"
        class="nav__close"
        @click="$emit('close')"
      >
        <i class="isif isif-close" />
      </div>
    </nav>
    <template v-if="tags.some(isJoorActionTag) && isInJoorPlatform">
      <div
        class="marker-select"
      >
        <select
          name="price-type-select"
          class="marker-info-select"
          :value="currentPriceType.id"
          @change="updatePriceType"
        >
          <option
            v-for="price in availablePriceType"
            :key="price.id"
            :value="price.id"
          >
            {{ price.currency_code }}
          </option>
        </select>
      </div>
    </template>
    <main-view
      v-if="!isPreviewActive"
      class="main-view"
      v-bind="$props"
      :i18n-field-value="i18nFieldValue"
      :get-action-mutate="getActionMutate"
      :available-price-type="availablePriceType"
      @preview="isPreviewActive = whiteLabelCeline; index = $event"
    />
    <image-view
      v-else
      class="image-view"
      :tags="tags"
      :index.sync="index"
    />
  </div>
</template>

<script>
import MainView from './MainView'
import ImageView from './ImageView'
import { WHITE_LABEL_CELINE } from '~js/constants'
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

export default {
  name: 'ViewerLayerMultitagMobileIndex',
  components: {
    MainView,
    ImageView
  },
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    i18nFieldValue: {
      type: Function,
      default: () => {}
    },
    getActionMutate: {
      type: Function,
      default: () => {}
    },
    disableClose: {
      type: Boolean,
      default: false
    },
    isJoorActionTag: {
      type: Function,
      default: () => {}
    },
    customSetting: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      index: 0,
      isPreviewActive: false,
      whiteLabelCeline: WHITE_LABEL_CELINE
    }
  },
  computed: {
    ...mapGetters('joor', [
      'priceType',
      'products',
      'skus',
      'currentPriceType',
      'accessToken',
      'orders',
      'isInJoorPlatform',
      'collections'
    ]),

    availablePriceType () {
      if (this.tags.some(this.isJoorActionTag) &&
      this.priceType.length > 0) {
        const joorTags = this.tags.filter(this.isJoorActionTag)
        const skuIdsList = joorTags.map(tag => this.products[tag.customAttribute.joorProductId]).filter(tag => tag)
        const priceBySkuIds = skuIdsList.reduce((priceBySkuIds, skuIds) => {
          skuIds.forEach(skuId => {
            if (this.skus[skuId]) {
              priceBySkuIds.push(...this.skus[skuId])
            }
          })
          return priceBySkuIds
        }, [])
        const availablePriceType = priceBySkuIds
          .filter(price => this.priceType.some(priceType => priceType.id === price.price_type.id))
          .map(price => {
            const clonePrice = _.cloneDeep(price)
            clonePrice.price_type.skus = {
              [clonePrice.sku_id]: {
                skuId: clonePrice.sku_id,
                wholesale_value: clonePrice.wholesale_value,
                retail_value: clonePrice.retail_value
              }
            }
            return clonePrice.price_type
          })
          .reduce((priceTypes, currentPrice) => {
            const targetPriceType = priceTypes.find(priceType => priceType.id === currentPrice.id)
            if (targetPriceType) {
              targetPriceType.skus = Object.assign(targetPriceType.skus, currentPrice.skus)
            } else {
              priceTypes.push(currentPrice)
            }
            return priceTypes
          }, [])
        return availablePriceType
      }
      return []
    }
  },
  methods: {
    ...mapActions('joor', [
      'setCurrentPriceType'
    ]),
    updatePriceType (event) {
      if (event.target.value) {
        const selectedPriceType = this.availablePriceType.find(priceType => priceType.id === event.target.value)
        this.setCurrentPriceType(selectedPriceType)
      } else {
        this.setCurrentPriceType({})
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  $nav-height = 20px
  .mobile {
    height: 100%
    display: flex
    flex-direction: column
    overflow: hidden
    position: relative
  }
  .nav {
    position: absolute
    width: 100%
    display: flex
    .nav__prev {
      cursor: pointer
    }
    .nav__close {
      margin-left: auto
      cursor: pointer
      z-index: 1
      filter: drop-shadow(0 0 1px rgba(#000, .75))
    }
  }
  .main-view {
    height: 100%
    flex: 1
  }
  .image-view {
    margin-top: $nav-height
    height: 100%
    flex: 1
  }
  .marker-select {
    margin: 12px 0
  }
  .marker-info-select {
    margin-right: 1rem
    padding: 4px
    font-size: 14px
    max-width: 108px

    &:focus {
      outline: none
    }
  }
</style>
